import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import DupontIconButton from "components/DupontIconButton";
import { valueStrings } from "constants/constantStrings";
import React, { useState } from "react";
import TrendHealth from "../../../assets/SvgIcon/cardviewMenu/trend_Health";
import TimeseriesPlotly from "./../Timeseries/TimeseriesPlotly";

const useStyles = makeStyles(theme => ({
  typography: {
    padding: "0px",
    width: "80vh"
  },
  root: {
    "& .MuiPaper-root": {
      boxShadow: "0px 0px 8px #00000033;",
      padding: "10px"
    },
    "& .MuiTypography-body1": {
      font: "normal normal normal 12px/16px Noto Sans",
      color: "#969696"
    }
  }
}));

export default function TagPopover(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [error, setError] = useState(false);

  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <div>
      <div onClick={handleClick} className="pointer">
        <DupontIconButton tooltip={valueStrings.trend} active={open}>
          <TrendHealth />
        </DupontIconButton>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        <Typography className={`${classes.typography} ${error ? "card-error" : ""} `}>
          <TimeseriesPlotly className="fullWidth" tagData={props.tagData} setError={setError} isDaySeries />
        </Typography>
      </Popover>
    </div>
  );
}
